/** Parse a string and return the enum value if the match is exact, otherwise throws. */
export function parseEnum<T extends Record<string, string>>(enumObj: T, value: string): T[keyof T] {
    const values = Object.values(enumObj);
    if (values.includes(value)) {
        return value as T[keyof T];
    }
    throw new Error(`Invalid value "${value}". Expected one of: ${values.join(", ")}`);
}
